import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UigDeleteToggleStatusComponent } from './uig-delete-toggle-status.component';
import {
  ConfirmationMessageModule,
  MessageModule
} from '@spartacus/organization/administration/components';
import {
  I18nConfig,
  I18nModule,
  provideConfig
} from '@spartacus/core';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    MessageModule,
    ConfirmationMessageModule
  ],
  declarations: [UigDeleteToggleStatusComponent],
  providers: [
    provideConfig(<I18nConfig>{
      i18n: {
        chunks: { uigOrgUser: ['uigOrgUser'] },
      }
    }),
  ],
  exports: [UigDeleteToggleStatusComponent]
})
export class UigDeleteToggleStatusModule { }
